import React from 'react'

import { Modal } from '@zambezi/sdk/modal'

import { closeModal$ } from '@apiEnabler/api-enabler-common/lib/intents'

import {
  cancelLogOut$,
  confirmLogOut$,
  extendSession$,
  startLogOut$,
} from '@apiEnabler/ob-common/lib/intents'
import ConfirmLogoutModal from './ConfirmLogoutModal'
import ConfirmCountdownModal from '@apiEnabler/ob-common/lib/view/ConfirmCountdownModal'
import ChangesTo90DayAccessModal from '@apiEnabler/ob-common/lib/view/ChangesTo90DayAccessModal'
import Loader from '@apiEnabler/ob-common/lib/view/Loader'

import { ACCESS_SECTIONS } from '../../accesses'
import { FUNDS_CHECK_SECTIONS } from '../../funds-checks'
import { VRP_SECTIONS } from '../../vrp'
import { SWEEPING_SECTIONS } from '../../sweeping'
import {
  ceaseCancelAccess$,
  confirmCancelAccess$,
  ceaseCancelFundsCheck$,
  confirmCancelFundsCheck$,
  ceaseCancelVrp$,
  confirmCancelVrp$,
  ceaseCancelSweeping$,
  confirmCancelSweeping$,
  ceaseCancelLink$,
  confirmCancelLink$,
} from '../../intents'

import ContinueAccessModal from './ContinueAccessModal'
import StatusMeaningModal from './StatusMeaningModal'
import MobileNavigationModal from './MobileNavigationModal'
import ServiceProviderInfoModal from './ServiceProviderInfoModal'
import CancelAccessModal from './CancelAccessModal'
import CancelFundsCheckModal from './CancelFundsCheckModal'
import CancelVrpModal from './CancelVrpModal'
import CancelLinkModal from './CancelLinkModal'

import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'

const Modals = ({ modal, brand }) =>
  ({
    'link-cancel.confirm': (
      <CancelLinkModal
        open
        link={modal.get('data')}
        onCancel={() => ceaseCancelLink$.complete()}
        onConfirm={() => confirmCancelLink$.complete()}
      />
    ),
    'link-cancel.loading': (
      <Modal className={modalStyle.modal} open title="Cancelling link...">
        <Loader text="" />
      </Modal>
    ),
    'changes-90-day-auth-access.detail': (
      <ChangesTo90DayAccessModal open onClose={() => closeModal$.next()} />
    ),
    'access-cancel.confirm': (
      <CancelAccessModal
        open
        consent={modal.get('data')}
        onCancel={() => ceaseCancelAccess$.complete()}
        onConfirm={() => confirmCancelAccess$.complete()}
      />
    ),
    'access-cancel.loading': (
      <Modal className={modalStyle.modal} open title="Cancelling access...">
        <Loader text="" />
      </Modal>
    ),
    'vrp-cancel.confirm': (
      <CancelVrpModal
        open
        consent={modal.get('data')}
        onCancel={() => ceaseCancelVrp$.complete()}
        onConfirm={() => confirmCancelVrp$.complete()}
      />
    ),
    'vrp-cancel.loading': (
      <Modal className={modalStyle.modal} open title="Cancelling access...">
        <Loader text="" />
      </Modal>
    ),
    'sweeping-cancel.confirm': (
      <CancelVrpModal
        open
        consent={modal.get('data')}
        onCancel={() => ceaseCancelSweeping$.complete()}
        onConfirm={() => confirmCancelSweeping$.complete()}
      />
    ),
    'sweeping-cancel.loading': (
      <Modal className={modalStyle.modal} open title="Cancelling access...">
        <Loader text="" />
      </Modal>
    ),
    'funds-check-cancel.confirm': (
      <CancelFundsCheckModal
        open
        consent={modal.get('data')}
        onCancel={() => ceaseCancelFundsCheck$.complete()}
        onConfirm={() => confirmCancelFundsCheck$.complete()}
      />
    ),
    'funds-check-cancel.loading': (
      <Modal className={modalStyle.modal} open title="Cancelling access...">
        <Loader text="" />
      </Modal>
    ),
    'access-status-meaning.detail': (
      <StatusMeaningModal
        open
        onClose={() => closeModal$.next()}
        sections={ACCESS_SECTIONS}
        title="Connection Status Glossary"
      />
    ),
    'continue-access-info.show': (
      <ContinueAccessModal
        className={modalStyle.modal}
        open
        onCancel={() => closeModal$.next()}
      />
    ),
    'funds-check-status-meaning.detail': (
      <StatusMeaningModal
        open
        onClose={() => closeModal$.next()}
        sections={FUNDS_CHECK_SECTIONS}
        title="Funds Check Status Glossary"
      />
    ),
    'vrp-status-meaning.detail': (
      <StatusMeaningModal
        open
        onClose={() => closeModal$.next()}
        sections={VRP_SECTIONS}
        title="Variable Recurring Payments Status Glossary"
      />
    ),
    'sweeping-status-meaning.detail': (
      <StatusMeaningModal
        open
        onClose={() => closeModal$.next()}
        sections={SWEEPING_SECTIONS}
        title="Sweeping Payments Status Glossary"
      />
    ),
    'logout.confirm': (
      <ConfirmLogoutModal
        className={modalStyle.modal}
        open
        onCancel={() => cancelLogOut$.complete()}
        onConfirm={() => confirmLogOut$.complete()}
      />
    ),
    'nav-mobile': (
      <MobileNavigationModal
        open
        onClose={() => closeModal$.next()}
        onConfirm={() => startLogOut$.next()}
        brand={brand}
      />
    ),
    'timeout.countdown': (
      <ConfirmCountdownModal
        className={modalStyle.modal}
        open
        time={modal.get('data')}
        onCancel={() => confirmLogOut$.complete()}
        onConfirm={() => extendSession$.next()}
      />
    ),
    'service-provider.info': (
      <ServiceProviderInfoModal
        open
        onCancel={() => closeModal$.next()}
        brand={brand}
      />
    ),
  }[modal.get('type')])

export default Modals
